import 'jquery';
import _ from 'lodash';

$('.toggle-search-button').on('click', function () {
  $('body').toggleClass('toggled-view');

  // Focus search input if we are opening the search input
  if ($('body').hasClass('toggled-view')) {
    $('.site-header__search-wrap .search-form input:first').focus();
  }
});

$('.toggle-menu-button').on('click', function () {
  $('body').toggleClass('toggled-view');
});

$('.sub-menu-trigger').on('click', function () {
  $(this).parent().toggleClass('sub-menu-open');
});

$(window).bind("load", function () {
  var $menu = $(".site-header__lower"),
    // handle = null,
    scrollTop = 0,
    triggerHeight = $menu.offset().top,
    $w = $(window);

  var triggerNav = function () {
    scrollTop = $w.scrollTop();

    if (scrollTop > triggerHeight) {
      $menu.addClass('site-header--attached');
    } else {
      $menu.removeClass('site-header--attached');
    }
  }

  triggerNav();

  $w.on('scroll', _.throttle(function () {
    triggerNav();
  }, 5));
});

var dd = document.getElementById('jsdropdown');
var ddarrow = document.getElementById('dd-arrow');

document.addEventListener('click', function (event) {
  if (dd) {
    var isClickInside = dd.contains(event.target);

    if (isClickInside) {
      event.preventDefault();
      dd.parentElement.classList.toggle('active');
      ddarrow.classList.toggle('down');
    } else {
      dd.parentElement.classList.remove('active');
      ddarrow.classList.remove('down');
    }
  }
});

$('.btn-details').on("click", function (event) {
  $(this).parent().parent().parent().toggleClass('open');
  event.preventDefault();
});

jQuery( document ).ready(function() {
  if (jQuery( "#hd-step-4" ).length) {
    var treatment_dict = {
        660262: 'undersökning',
        1837948: 'akut undersökning',
        1491439: 'tandhygienist',
        2337856: 'konsultation tandimplantat',
        2341301: 'osynlig tandställning',
    };
    var url = window.location.href;
    try {
      var treatment_id = url.split('treatment=')[1].split(',')[0];
    }
    catch(e) {
      //pass
    }
    jQuery('span.hd-treatmentname').text(treatment_dict[treatment_id]);
  }
});



// WEBPACK FOOTER //
// ./scripts/components/sitenav.js